export function priceToString(price: number, currency: string) {
    if (typeof price === 'undefined' || price === null || isNaN(price)) return '?'
    const priceString = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    switch (currency.toLowerCase()) {
        case 'eur':
        case '€':
            return `€${priceString}`
        case 'gbp':
        case '£':
            return `£${priceString}`
        case 'chf':
            return `${priceString} ${currency.toUpperCase()}`
        case 'pln':
        case 'zł':
            return `${priceString} ${currency.toLowerCase()}`
        case 'usd':
        case '$':
            return `$${priceString}`
        default: throw new Error(`Unsupported currency ${currency}`)
    }
}